import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { benchmarkkpi, tranbenchmarkkpi, practicebmtransactionadd } from './../../../../models/slakpi';
import { division, user, department, targetMaster, benchmarkprogressmaster } from './../../../../models/admin';
import { UtilityService } from '../../../../services/utility.service';
import { BMApiService } from '../../../../services/bm.service';
import { SpinnerVisibilityService } from 'ng-http-loader';
import Swal from 'sweetalert2'
import { UserService } from '../../../../services/user.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { uniqBy } from 'lodash';
import {
  AngularGridInstance,
  Column,
  FieldType,
  Filters,
  Formatter,
  GridOption,
  FileType,
  Formatters,
  MenuCallbackArgs,

} from 'angular-slickgrid';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { AdminApiService } from '../../../../services/admin.service';
import { formatDate } from '@angular/common';
import { ToasterService } from '../../../../toaster.service';

@Component({
  selector: 'app-practice-bm-progress-transaction-list',
  templateUrl: './practice-bm-progress-transaction-list.component.html',
  styleUrls: ['./practice-bm-progress-transaction-list.component.css']
})
export class PracticeBMProgressTransactionListComponent implements OnInit {
  public gridApi: any;
  public gridColumnApi: any;
  public columnDefs: any;
  public defaultColDef: any;
  public rowData: any;
  public PopoverModule;
  modalRef: BsModalRef;
  @ViewChild('addtemplate', { static: false }) addtemplate: TemplateRef<any>;
  columnDefinitions: Column[];
  gridOptions: GridOption;
  dataset: any;
  public selTab = true;
  public data: any;
  public gridload: number = 0;
  submitted: boolean = false;

  invalid: boolean = false;
  public loading: boolean = true;
  public pageAction: string = 'add';
  objPM: any = new benchmarkprogressmaster();
  angularGrid: AngularGridInstance;
  bmProgressMasterData: object[];
  selected_itemUno: number = 0;
  pbmtype: any;
  isTitle: boolean = false;
  continentDDList: any = [];
  isContinentDD: boolean = false;
  titleName: string;
  Title2: boolean;
  countryDDList: any;
  isCountryDD: boolean = false;
  isRegionDD: boolean = false;
  sourceTypeDDList: any = [];
  regionDDList: any = [];
  isSourceTypeDD: boolean = false;
  isSourceDesc: boolean = false;
  utilityTypeDDList: any = [];
  peerTypeDDList: any = [];
  isUtilityTypeDD = false;
  isPeerTypeDD = false;
  isBusinessModel: boolean = false;
  isTechnologyUsed: boolean = false;
    bmProgressTypeDDList: Object;
    editlabel: string;
    transactionRoutingLink: string;
  searchText: string;

  user: any = {};
  login_UserID: string;
  isAdmin: boolean = false;
  public isBMChampion: boolean = false;
  public isBMTeam: boolean = false;
  public isBMVisitor: boolean = false;
  public isBMAdmin: boolean = false;
    noDataImg: string;
    tenantUno: any;

  constructor(private formBuilder: FormBuilder, public restApi: AdminApiService, private toaster: ToasterService, public restBMApi: BMApiService,private route: ActivatedRoute,
    public utilityService: UtilityService, private router: Router, private spinner: SpinnerVisibilityService, private userService: UserService, private modalService: BsModalService) {
    this.user = this.userService.getUserInfo();
    this.login_UserID = this.user.id;
    this.tenantUno = this.user.tenantUno;
    this.ValidateUserAccess();
  }
  //Method used To Validate User Permission

  ValidateUserAccess() {
    

    this.isAdmin = (this.user.role == 'Administrator' || this.user.role == 'BM Administrator') ? true : false;

    if (this.user.role == 'BM Champions')
      this.isBMChampion = true;
    if (this.user.role == 'BM Team')
      this.isBMTeam = true;
    if (this.user.role == 'BM Visitor')
      this.isBMVisitor = true;
    if (this.user.role == 'BM Administrator') { this.isBMAdmin = true; }

    if (!this.isAdmin) {
      let userPermissionData = this.userService.getUserRights("Practice Benchmark Setup");
      if (userPermissionData != null && userPermissionData != undefined && userPermissionData.length > 0) {
        if (userPermissionData[0].showPage == 1) {

        }
        else {
          this.router.navigateByUrl('/access-denied');
        }
      }
    }

  }

  ngOnInit() {
    this.userService.CheckLogin();
    //this.modalRef.hide();
    this.gridOptions = {
      autoHeight: true,
      enableAutoResize: true,
      enablePagination: true,
      pagination: {
        pageSizes: [5, 10, 20, 50, 100, 500],
        pageSize: 20
      },
      enableFiltering: true,
      alwaysShowVerticalScroll: false,
      enableRowSelection: true,
      autoResize: {
        containerId: 'musherat-grid',
        delay: 0,
        sidePadding: 10,
        bottomPadding: 10
      },
      enableExcelExport: true,
      enableExcelCopyBuffer: true,
      enableFilterTrimWhiteSpace: true,
      showCustomFooter: true, // display some metrics in the bottom custom footer
      enableContextMenu: true,
      enableCellMenu: true,
      forceFitColumns: true,

    };
  
    this.loadPerformanceMaster();
    this.getBMProgressTypeDD();
    this.noDataImg = this.utilityService.getnodataImage();
  }

  angularGridReady(angularGrid: AngularGridInstance) {
    this.angularGrid = angularGrid;
    this.userService.angularGrid = angularGrid;
  }
  uniqueArray(arrayList, val, label) {
    var temp = this;
    var aList = [];
    if (arrayList) {
      for (var i = 0, l = arrayList.length; i < l; i++)
        if (aList.filter(item => item.label == temp.Checklabel(arrayList[i][label])).length == 0) {

          aList.push({
            'value': this.CheckValue(arrayList[i][val]), 'label': this.Checklabel(arrayList[i][label])
          });
        }
    }


    aList.sort((a: any, b: any) => {
      if (a['value'] < b['value']) {
        return -1;
      } else if (a['value'] > b['value']) {
        return 1;
      } else {
        return 0;
      }
    });
    return aList;
  }

  Checklabel(val) {
    if (val != undefined && val != null && val != '' && val != ' ')
      return val;
    else
      return ''

  }

  CheckValue(val) {
    if (val != undefined && val != null && val != '' && val != ':')
      return val;
    else
      return ' ';

  }

  IsNull(val) {
    if (val != undefined && val != null && val != '') {
      val = val.trim()
      return val.charAt(0).toUpperCase() + val.slice(1);
    }
    else
      return ' ';

  }
  

  searchGrid() {

    if (this.searchText != "") {
      this.dataset = this.data.filter(a =>
        a.projectName && a.projectName.toLowerCase().includes(this.searchText.toLowerCase())
        || (a.division && a.division.toLowerCase().includes(this.searchText.toLowerCase()))
        || (a.projectManager && a.projectManager.toLowerCase().includes(this.searchText.toLowerCase()))
        || (a.plannedStartDate && a.plannedStartDate.toLowerCase().includes(this.searchText.toLowerCase()))
        || (a.plannedEndDate && a.plannedEndDate.toLowerCase().includes(this.searchText.toLowerCase())));
    }
    else
      this.dataset = this.data;
  }
  setGridBMProgressDefn() {
    let temp = this;
    this.columnDefinitions = [
      {
        id: 'projectName', name: 'Project Name', field: 'projectName', sortable: true, type: FieldType.string, filterable: true, width: 80,
        filter: {
          collection: this.uniqueArray(this.dataset, 'projectName', 'projectName'),
          model: Filters.multipleSelect,

        }
      },
      {
        id: 'division', name: 'Division', field: 'division', sortable: true, type: FieldType.string, filterable: true, width: 50,
        filter: {
          collection: this.uniqueArray(this.dataset, 'division', 'division'),
          model: Filters.multipleSelect,

        }
      },
      {
        id: 'projectManager', name: 'Project Manager', field: 'projectManager', sortable: true, type: FieldType.string, filterable: true, width: 40,
        filter: {
          collection: this.uniqueArray(this.dataset, 'projectManager', 'projectManager'),
          model: Filters.multipleSelect,

        }
      },
     
      {
        id: 'plannedStartDate', name: 'Planned Start', field: 'plannedStartDate', sortable: true, type: FieldType.string, filterable: true, width: 10,
        filter: {
          collection: this.uniqueArray(this.dataset, 'plannedStartDate', 'plannedStartDate'),
          model: Filters.multipleSelect,

        }
      },
      {
        id: 'plannedEndDate', name: 'Planned End', field: 'plannedEndDate', sortable: true, type: FieldType.string, filterable: true, width: 10,
        filter: {
          collection: this.uniqueArray(this.dataset, 'plannedEndDate', 'plannedEndDate'),
          model: Filters.multipleSelect,

        }
      },
    
      
      {
        id: 'action', name: 'Action', field: 'action', cssClass: 'blue', width: 10,
        excludeFromExport: true,
        formatter: this.actionFormatter,
        cellMenu: {
          hideCloseButton: false,
          commandTitleKey: 'COMMANDS',
          
          commandItems: [
            {
              command: 'delete-row', titleKey: 'EDIT_ROW', positionOrder: 62, title: this.editlabel,
              itemVisibilityOverride: (args: MenuCallbackArgs) => {
                let data = args.dataContext;

                if (this.isBMChampion || this.isBMVisitor)
                  return false;
                else return true;
              },
              iconCssClass: 'fa fa-pencil-square-o', cssClass: 'blue', textCssClass: 'bold',
              action: (e, args) => {
                this.pageAction = 'edit';
                

                let rdata: any = args.dataContext;
                 let itemID = rdata.id;
               
                this.router.navigate([this.transactionRoutingLink], { queryParams: { itemUno: itemID } });

              },
              // only show command to 'Delete Row' when the task is not completed

            },
            { divider: true, command: '', positionOrder: 63 },
            {
              command: 'delete-row', titleKey: 'DELETE_ROW', positionOrder: 64, title: 'Delete',
              itemVisibilityOverride: (args: MenuCallbackArgs) => {
                let data = args.dataContext;

                if (this.isBMChampion || this.isBMVisitor)
                  return false;
                else return true;
              },
              iconCssClass: 'fa fa-trash', cssClass: 'red', textCssClass: 'bold',
              action: (e, args) => {
                Swal.fire({
                  title: 'Delete',
                  text: 'Please confirm to delete the record',
                  type: 'warning',
                  showCancelButton: true,
                  confirmButtonText: 'Ok',
                  cancelButtonText: 'Cancel'
                }).then((result) => {
                  if (result.value) {
                    this.pageAction = 'delete';
                    this.DeletePracticeBMProject(args.dataContext);
                  } else if (result.dismiss === Swal.DismissReason.cancel) {

                  }
                })
              },
              // only show command to 'Delete Row' when the task is not completed

            },


          ],
        }
      }

    ]


  }

 
  actionFormatter: Formatter = (row, cell, value, columnDef, dataContext) => {
    return `<div class="fake-hyperlink"> <i class="fa fa-ellipsis-h fa-lg"></i></div>`;
  };

  loadPerformanceMaster() {
    this.spinner.show();
    
    let inpValue = new practicebmtransactionadd();
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 1;
    inpValue.userUno = this.login_UserID;
    inpValue.flag = 'Setup';
    inpValue.tenantUno = this.tenantUno;
    this.restBMApi.getProjects(inpValue)
      .subscribe(data => {
        
        const mockDataset = [];
        this.searchText = '';
        let filterDataSet = uniqBy(data, 'id');

        this.data = filterDataSet.filter(a => a.status == 'Draft' || a.status == '');
          this.editlabel = "Edit";
          this.transactionRoutingLink = '/practice-bm-progress-transaction-add';
      
        for (let i = 0; i < this.data.length; i++) {

          mockDataset[i] = {
            id: this.data[i].id,
            projectName: this.data[i].projectName,
            division: this.data[i].division,
            projectManager: this.data[i].projectManager,
            peer: this.data[i].peer,
            comments: this.data[i].comments,
            currentAction: this.data[i].currentAction,
            status: this.data[i].status,
            plannedStartDate: formatDate(this.data[i].plannedStartDate, 'dd-MM-yyy', 'en-US'),
            plannedEndDate: formatDate(this.data[i].plannedEndDate, 'dd-MM-yyy', 'en-US')
          };
        }
        this.dataset = mockDataset;
        if (mockDataset.length > 0) {
          this.setGridBMProgressDefn();
        }
        else {
          this.setGridBMProgressDefn();
        }
        this.bmProgressMasterData = mockDataset;
        this.loading = false;
        this.spinner.hide()
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });
  }


  openModalWithClass(addtemplate: TemplateRef<any>) {
    
    this.pageAction == "add";
    this.objPM = new benchmarkprogressmaster();

    this.modalRef = this.modalService.show(
      addtemplate,
      Object.assign({}, { class: 'gray modal-lg' })
    );
  }

  onSubmit(val1) {
    
    if (!val1) { Swal.fire('Error', 'Please enter the required information.', 'error'); return }

    else {
      this.AddEditPerformanceMaster(this.objPM)
    }
  }

  AddEditPerformanceMaster(data1: any) {
    
    //if (this.kpiForm.invalid) {
    //  Swal.fire('Error', 'Something went wrong!', 'error')
    //  return false;
    //}


    if (this.DuplicateNameCheck(this.utilityService.isNumericNull(data1.id), this.utilityService.isStringNull(data1.bmProgressName), '')) {
      Swal.fire('Error', 'Duplicates are not allowed', 'warning');
      return false;
    }
    else {

      let objPF = new benchmarkprogressmaster();
      objPF = data1;
      objPF.bmProgressName = (objPF.bmProgressName) ? objPF.bmProgressName.toString() : '';
      objPF.bmProgressValue = (objPF.bmProgressValue) ? objPF.bmProgressValue : 0;
      objPF.bmProgressTypeUno = objPF.bmProgressTypeUno;
      objPF.userUno = this.login_UserID;
      objPF.condition = (this.pageAction == "add") ? 0 : 1;
      objPF.tenantUno = this.tenantUno;
      objPF.tableName = this.pbmtype;
      this.restApi.addEditBMProgressMaster(objPF)
        .subscribe(data => {

          if (data != null && data != undefined && data != '') {
            Swal.fire('Error', 'Something went wrong', 'error');
            this.spinner.hide();
          }
          else {
            Swal.fire({
              type: 'success',
              title: 'Item saved.',
              showConfirmButton: false,
              timer: 1500
            })
            setTimeout(() => {
              this.objPM = new benchmarkprogressmaster();
              this.spinner.hide();
              this.loadPerformanceMaster();
              this.modalRef.hide();
            }, 500);

          }



        },
          (error) => {
            //Called when error
            this.spinner.hide();
          }
        ).add(() => {
          //Called when operation is complete (both success and error)
          //this.spinner.hide();
        });
      return true;
    }
  }
  DuplicateNameCheck(itemUno: number, nameEn: string, nameAr: string) {
    
    if (this.data != null && this.data != undefined) {
      var rtnValue = false;
      this.data.forEach((grdData) => {
        if (((itemUno != grdData.id) || (itemUno == grdData.id && this.selected_itemUno != grdData.id))
          &&
          (grdData.bmProgressName.toLocaleLowerCase() == nameEn.trim().toLowerCase())) {
          rtnValue = true;
        }
      

      });

      return rtnValue;
    }
  }


  DeletePracticeBMProject(data1: any) {
    
    let objpfm = new practicebmtransactionadd();
    objpfm.id = data1.id;
    objpfm.userUno = this.login_UserID;
    objpfm.tenantUno = this.tenantUno;
    this.restBMApi.deletePracticeBMProject(objpfm)
      .subscribe(data => {
        
        if (data != null && data != undefined && data != '' && data != 'failure') {
        
          this.toaster.show('error', 'Error', 'Something went wrong.');
        }
        else {
          this.toaster.show('success', 'Success', 'Item deleted.');
          this.loadPerformanceMaster();
         
         
        }


        this.spinner.hide();
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });

  }


  getBMProgressTypeDD() {

    let inpValue = new benchmarkprogressmaster();
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 1;
    inpValue.tenantUno = this.tenantUno;
    inpValue.userUno = this.login_UserID;
    this.restApi.getBMProgressTypeDD(inpValue)
      .subscribe(data => {

        this.bmProgressTypeDDList = data;
      },
        (error) => {
          //Called when error
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
      });
  }

  
  Reset() {
    this.modalRef.hide();
    setTimeout(() => {
      this.objPM = new benchmarkprogressmaster();
      this.pageAction = 'add';
    }, 300);


  }
  
}
